import { Row } from "antd";
import { LogoColorSVG } from "../../assets/svg/SvgIcons";
import { APP_NAME, APP_TAGLINE } from "../../constants/webapp";
import { secondaryColor } from "../../theme/Theme";

export const LogoView = () => (
  <Row
    className="flexCenter gap10"
    style={{
      border: "1px solid #ddd",
      padding: 20,
      borderRadius: 10,
      marginBottom: 20,
    }}
  >
    <img src={LogoColorSVG} height={40} width={40} />
    <div style={{ lineHeight: 1.2 }}>
      <p
        style={{
          fontSize: 20,
          fontWeight: "bolder",
          color: secondaryColor,
        }}
        className="extraBold"
      >
        {APP_NAME}
      </p>
      <p className="font11">{APP_TAGLINE}</p>
    </div>
  </Row>
);
